import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Form} from 'formik';
import FieldInput from '../../components/FieldInput';
import Button from '../../components/Button';
import ErrorValidation from '../../components/ErrorValidation';
import styles from './styles.module.scss';

const Step3View = ({isValid}) => {
  return (
    <Form className={styles.formContainer}>
      <FieldInput
        fieldId='phoneNumber'
        label={(
          <FormattedMessage
            id='step3.form.phone.label'
            defaultMessage='Phone'
          />
        )}
        containerStyles={styles.input}
        disabled={true}
      />
      <FieldInput
        fieldId='city'
        label={(
          <FormattedMessage
            id='step3.form.city.label'
            defaultMessage='City / Town'
          />
        )}
        containerStyles={styles.input}
      />
      <FieldInput
        fieldId='street'
        label={(
          <FormattedMessage
            id='step3.form.street.label'
            defaultMessage='Street / mailbox'
          />
        )}
        containerStyles={styles.input}
      />
      <div className={`${styles.input} ${styles.spouse}`}>
        <FieldInput
          fieldId='houseNum'
          label={(
            <FormattedMessage
              id='step3.form.house.label'
              defaultMessage='House number'
            />
          )}
          containerStyles={styles.input}
        />
        <FieldInput
          fieldId='appartmentNum'
          label={(
            <FormattedMessage
              id='step3.form.apartment.label'
              defaultMessage='Apartment number'
            />
          )}
          containerStyles={styles.input}
        />
      </div>

      <Button
        type='submit'
        label={(
          <FormattedMessage
            id='common.form.button.save'
            defaultMessage='Start'
          />
        )}
      />
      {!isValid && <ErrorValidation />}
    </Form>
  )
};

Step3View.propTypes = {
  isValid: PropTypes.bool,
};

export default Step3View;
